import useAddVodProductMutation from 'hooks/useAddVodProductMutation.js';
import { useEffect } from 'react';
import useVodProductsQuery from 'hooks/useVodProductsQuery.js';
import useFetchProductMutation from 'components/ProductImport/useFetchProductMutation.js';

const noop = () => {};

export const exampleProductUrl = 'https://demo.bambuser.com/product/black-linen-blazer';

const useCreateExampleProduct = () => {
  const { data: { data: products = [] } = {}, isFetched: isProductsFetched } = useVodProductsQuery();

  const { mutate: addVodProduct } = useAddVodProductMutation({
    onSuccess: noop,
    onError: noop,
    onSettled: noop,
  });
  const { mutate: fetchProduct } = useFetchProductMutation({
    onSuccess: (data) => {
      const body = data.body;
      addVodProduct({ ...body, opts: { withPlatformEvent: false } });
    },
    onError: noop,
  });

  useEffect(() => {
    if (isProductsFetched && products.length === 0) {
      fetchProduct({ url: exampleProductUrl });
    }
  }, [fetchProduct, isProductsFetched, products.length]);
};

export default useCreateExampleProduct;
